import { FC } from 'react';
import { Files } from './files';
import { AzureBlobResponse } from '../../../../../shared/file-upload/azure-upload';
import { useMutation, useQuery } from '@apollo/client';
import { StaffCaseFilesContainerIdentityVerificationCaseV1Document, StaffCasesFilesContainerIdentityVerificationCaseV1UpdateDocument } from '../../../../../../generated';
import { message } from 'antd';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
interface FilesContainerProps {
  caseId: string;
  isCaseOrApplicant: string;
}
export const FilesContainer: FC<FilesContainerProps> = (props) => {
  const {
    data: caseData,
    loading,
    error
  } = useQuery(StaffCaseFilesContainerIdentityVerificationCaseV1Document, {
    variables: {
      identityVerificationCaseV1Id: props.caseId
    }
  });

  const [updatedIdentityVerificationCaseV1] = useMutation(StaffCasesFilesContainerIdentityVerificationCaseV1UpdateDocument);
  const handleOnUploadSuccess = async (response: AzureBlobResponse, fieldName: string, isPrivate: boolean) => {
    const assetPath = isPrivate ? 'private' : 'shared';
    const input = {
      id: props.caseId,
      assets: {
        [assetPath]: {
          [fieldName]: response.blobUrl,
          [`${fieldName}Version`]: response.versionId
        }
      }
    };
    updatedIdentityVerificationCaseV1({
      variables: {
        input
      }
    }).then((res) => {
      if (res.data?.identityVerificationCaseV1Update.status.success) {
        message.success('File uploaded successfully');
      } else {
        message.error('Failed to upload file: ' + res.data?.identityVerificationCaseV1Update.status.errorMessage);
      }
    });
  };

  return (
    <ComponentQueryLoader
      loading={loading}
      error={error}
      hasData={caseData?.identityVerificationCaseV1}
      hasDataComponent={
        <Files
          shared={true}
          caseId={props.caseId}
          onUploadSuccess={(response, fieldname, isPrivate) => handleOnUploadSuccess(response, fieldname, isPrivate)}
          caseState={caseData?.identityVerificationCaseV1?.state ?? ''}
          isAssigned={caseData?.identityVerificationCaseV1?.isCurrentUserAssigned ?? false}
          isCaseOrApplicant={props.isCaseOrApplicant}
        />
      }
    />
  );
};
